import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Link,
  Button,
  Typography
} from '@one-thd/sui-atomic-components';
import NullViewTexts from '../../../constants/NullViewTexts'

const NullViewContent = ({ carousel }) => {
  const {
    benefits,
    cardTitle,
    learnMoreText
  } = NullViewTexts;

  return (
    <div
      data-testid="null-view-content"
      className={classNames(
        'sui-flex sui-flex-col sui-grow sui-justify-between',
        {
          'sui-ml-4 sui-p-2 sui-max-w-96 sui-gap-2 sui-h-full': carousel,
          'sui-gap-2 @lg:sui-gap-4': !carousel
        }
      )}
    >
      <div 
        className={classNames(
          'sui-flex sui-flex-col',
          {
            '@6xl:sui-flex-row @6xl:sui-gap-2': !carousel
          })
        }
      >
        {
          cardTitle.map((line, index) => {
            return (
              <h3
                key={`title-line-${index+1}`}
                className={classNames(
                  'sui-font-display sui-text-pretty',
                  {
                    'sui-text-3xl': carousel,
                    'sui-text-3xl @4xl:sui-text-6xl': !carousel
                  }
                )}
              >
                {line}
              </h3>
            )
          })
        }
      </div>
      <ul className={classNames('sui-list-disc sui-list-outside sui-ml-4 sui-text-balanced',
        {
          'sui-mb-4': !carousel
        }
      )}
      >
        {benefits.map((benefit, index) => (
          <li
            key={`null-content-benefit-${index}`}
            className="sui-text-base sui-text-balanced"
          >
            {benefit}
          </li>
        ))}
      </ul>
      {
        carousel && (
          <Button
            variant="text"
            href="/c/create-a-quote"
          >
            {learnMoreText}
          </Button>
        )
      }
    </div>
  )
};

NullViewContent.propTypes = {
  carousel: PropTypes.bool
};

NullViewContent.defaultProps = {
  carousel: false
};

export default NullViewContent; 